module.exports = __webpack_public_path__ + "static/media/filter.8f362a7c.svg";